module.exports = __webpack_public_path__ + "static/media/grnplybtn.5dc29744.svg";